import { useParams } from 'react-router-dom';

import { Form } from 'common/components';
import {
  FormItemBoolean,
  FormItemSelectEnum,
} from 'pages/product-full-view/shared/components';

import { useGetProductSchema } from 'hooks';

import { useGetProductItemModules } from 'pages/product-full-view/components/product-new-detail-view/queries';
import { useProductDetail } from 'pages/product-full-view/components/product-new-detail-view/ProductDetailContext';
import FormSingleNestedValue from 'pages/product-full-view/components/product-new-detail-view/FormSingleNestedValue';
import { findChildPropertiesInSchema } from 'pages/product-full-view/components/product-new-detail-view/filterProductSchema';

export const FormItemAccessoriesOptics = (props) => {
  const {
    productModules,
    property,
    productEnums,
    handleValidate,
    deleteFieldForm,
    parentNestedIndex,
  } = props;

  const { formInstance } = useProductDetail();

  const opticReady = Form.useWatch('OpticReady', formInstance);

  return (
    <FormSingleNestedValue
      productModules={productModules}
      name={property.propertyName}
      property={property}
      productEnums={productEnums}
      parentNestedIndex={parentNestedIndex}
      handleValidate={handleValidate}
      deleteFieldForm={deleteFieldForm}
      isHideAddButton={opticReady === false}
      isDisabledAddButton={opticReady === null || opticReady === undefined}
    />
  );
};

export const FormItemSelectAccessoriesChildren = (props) => {
  const { property, nameFormItem, propertyEnums, labelCol } = props;

  const { formInstance } = useProductDetail();

  const opticIncluded = Form.useWatch(
    ['AccessoriesOptics', 'OpticIncluded'],
    formInstance
  );

  return (
    <FormItemSelectEnum
      property={property}
      nameFormItem={nameFormItem}
      propertyEnums={propertyEnums}
      labelCol={labelCol}
      disabled={!opticIncluded}
    />
  );
};

export const FormItemOpticIncluded = (props) => {
  const { property, name } = props;

  const { formInstance } = useProductDetail();

  return (
    <FormItemBoolean
      name={name}
      property={property}
      labelCol={{ span: 6 }}
      onChange={(event) => {
        if (!event.target.value) {
          let formValues = formInstance.getFieldsValue();
          formValues = {
            ...formValues,
            AccessoriesOptics: {
              ...formValues.AccessoriesOptics,
              TypeIncluded: null,
              Magnification: null,
              Objective: null,
              MainTubeSize: null,
              Reticle: null,
              AdjustmentType: null,
            },
          };
          formInstance.setFieldsValue(formValues);
        }
      }}
    />
  );
};

export const FormItemOpticReady = (props) => {
  const { property, parentModuleName = 'Accessories' } = props;

  const { id: productId } = useParams();

  const { formInstance } = useProductDetail();

  const { productSchema } = useGetProductSchema();

  const { dataProductModules } = useGetProductItemModules(productId);

  const accessoriesOpticsChildProperties = findChildPropertiesInSchema(
    productSchema,
    'AccessoriesOptics'
  );

  const handleChangeOpticReady = async (event) => {
    const value = event.target.value;

    if (value === true) {
      // Get the original AccessoriesOptics data from dataProductModules
      const accessoriesModule = dataProductModules?.productItemModules?.find(
        (item) => item?.moduleName === parentModuleName
      );

      const originalAccessoriesOpticsData =
        accessoriesModule?.data?.AccessoriesOptics;

      let dataToSet;

      if (
        originalAccessoriesOpticsData &&
        typeof originalAccessoriesOpticsData === 'object'
      ) {
        // Use original data from server if it exists
        dataToSet = { ...originalAccessoriesOpticsData };
      } else {
        // Initialize with null values if no original data exists
        dataToSet = {};
        accessoriesOpticsChildProperties.forEach((childProperty) => {
          dataToSet[childProperty.propertyName] = null;
        });
      }

      formInstance.setFieldsValue({
        AccessoriesOptics: dataToSet,
      });

      // Wait for state update and trigger validation to force re-render
      await new Promise((resolve) => setTimeout(resolve, 0));

      try {
        await formInstance.validateFields(['AccessoriesOptics']);
      } catch (error) {
        // Ignore validation errors
      }
    } else {
      formInstance.setFieldsValue({
        AccessoriesOptics: null,
      });

      await new Promise((resolve) => setTimeout(resolve, 0));

      try {
      } catch (error) {}
    }
  };

  return (
    <FormItemBoolean
      property={property}
      labelCol={{ span: 6 }}
      onChange={handleChangeOpticReady}
    />
  );
};
